/** Shared by the proposal check and runtime. Paths are relative JSON pointers. */
import contract from './questionnaire-questions.v1.schema.json';
export type QuestionIssue={path:string;field:string};
const object=(value:unknown):Record<string,unknown>=>value!==null&&typeof value==='object'&&!Array.isArray(value)?value as Record<string,unknown>:{};
export function questionIssues(value:unknown):QuestionIssue[]{
 const issues:QuestionIssue[]=[];
 const add=(path:string,field:string)=>issues.push({path,field});
 if(!Array.isArray(value)||value.length<contract.minItems||value.length>contract.maxItems){add('','questions');return issues;}
 const keys=new Set<string>();
 value.forEach((raw,index)=>{
  const q=object(raw),path=`/${index}`;
  if(typeof q.key!=='string'||!q.key.trim()||keys.has(q.key))add(path+'/key','key');else keys.add(q.key);
  if(typeof object(q.label).fr!=='string')add(path+'/label/fr','label.fr');
  if(!contract.items.properties.kind.enum.includes(String(q.kind)))add(path+'/kind','kind');
  if(!Array.isArray(q.options)||q.options.length<contract.items.properties.options.minItems||q.options.length>contract.items.properties.options.maxItems){add(path+'/options','options');return;}
  const options=new Set<string>();
  q.options.forEach((rawOption,j)=>{
   const option=object(rawOption),p=path+`/options/${j}`;
   if(typeof option.key!=='string'||!option.key.trim()||options.has(option.key))add(p+'/key','key');else options.add(option.key);
   if(typeof object(option.label).fr!=='string')add(p+'/label/fr','label.fr');
   if(typeof option.points!=='number'||!Number.isFinite(option.points))add(p+'/points','points');
  });
 });
 return issues;
}
